import React, { useState } from 'react'
import { Star } from 'lucide-react'

const StarRating = ({ value, onChange, choices = [], idPrefix = '' }) => {
  const [hovered, setHovered] = useState(null)

  const handleMouseEnter = (index) => setHovered(index)
  const handleMouseLeave = () => setHovered(null)
  const handleClick = (index) => {
    // Toggle off if clicked again
    if (value === index) {
      onChange(0)
    } else {
      onChange(index)
    }
  }

  return (
    <div className="flex gap-4">
      {[1, 2, 3, 4, 5].map((index) => {
        const isFilled = hovered ? index <= hovered : index <= value
        return (
          <div
            key={index}
            id={`rating-${idPrefix}-${index}`}
            className="group flex cursor-pointer flex-col items-center"
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(index)}
          >
            <Star
              className={`h-10 w-10 transition-colors duration-150 ${
                isFilled ? 'text-yellow-400' : 'text-gray-300'
              }`}
              fill={isFilled ? 'currentColor' : 'none'}
            />
            <span className="mt-1 text-center text-sm group-hover:font-medium">
              {choices[index - 1] || ''}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default StarRating
